import React from "react";
import {InfoButton, minuteInMS, Observer, RunInAction_Set, TextPlus, VDateTime} from "web-vcore";
import {GetEntries} from "js-vextensions";
import Moment from "moment";
import {CheckBox, Column, Row, RowLR, Select, Spinner, Text, TextArea, TextInput, TimeSpanInput} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {AutoEndType} from "../../../../Server/DB/engineConfigs/@EngineConfig.js";
import {GetLights_WithUserTag} from "../../../../Server/DB/lights.js";
import {LightType} from "../../../../Server/DB/lights/@Light.js";
import {GetScripts_WithUserTag} from "../../../../Server/DB/scripts.js";
import {store} from "../../../../Store/index.js";
import {EffectPreviewButton} from "../../../@Shared/TagTargetEntryUI.js";
import {colors} from "../../../../Utils/UI/GlobalStyles.js";
import {EngineConfigPanels_SharedProps, ExtendEngineConfigPanelSharedProps} from "../ConfigPanel_Local.js";
import {SettingUI} from "../../../../Server/DB/engineConfigs/@EngineConfig/@Shared/SettingUI.js";
import {observer_mgl} from "mobx-graphlink";
import {SpinnerForPercent} from "../../../../Utils/ReactComponents/SpinnerForPercent.js";
import {EffectPointerInput} from "../../../@Shared/EffectPointerInput.js";
import {EffectSource_values_alerts} from "../../../../Engine/LiveSession/Components/AlertsComp.js";

const GetSharedProps = (props: EngineConfigPanels_SharedProps)=>ExtendEngineConfigPanelSharedProps(props, c=>c.alerts, (c, v)=>c.alerts = v);

const splitAt = 200;

export const Alerts_ConfigUI = observer_mgl((props: {} & EngineConfigPanels_SharedProps)=>{
	const {client, enabled} = props;
	const sharedProps = GetSharedProps(props);
	const {config, ChangeConfig} = sharedProps;

	return (
		<Column mt={15} style={{background: "hsla(0,0%,100%,.1)", borderRadius: 5, padding: 5}}>
			<Row style={{fontSize: 18}}>Alerts</Row>

			<RowLR mt={5} splitAt={splitAt}>
				<Text>Add events for alert-types:</Text>
				<Row style={{gap: 5}}>
					{EffectSource_values_alerts.map(source=>(
						<CheckBox key={source} text={source.replace("alert_", "")} value={config.events_addForAlertTypes?.includes(source) ?? false} onChange={val=>{
							ChangeConfig(c=>{
								const arr = c.events_addForAlertTypes ?? [];
								if (val) {
									if (!arr.includes(source)) arr.push(source);
								} else {
									arr.Remove(source);
								}
								c.events_addForAlertTypes = arr;
							});
						}}/>
					))}
				</Row>
			</RowLR>

			<Row mt={15} style={{fontSize: 18, fontWeight: "bold"}}>Effects</Row>
			<RowLR mt={5} splitAt={splitAt}>
				<TextPlus info={`
					The light-effect to use for setting the light's brightness.
					Note: Currently, this light-effect is also used by Breath comp's "sync breathing with siren" activity.
				`.AsMultiline(0)}>Light effect:</TextPlus>
				<EffectPointerInput enabled={enabled} value={config.lightEffectPointer} onChange={val=>ChangeConfig(c=>c.lightEffectPointer = val)}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt}>
				<TextPlus info={`
					The base interval at which to update external (eg. light) effects, based on alert states. (0 = disabled)
					Note: Normally, another source [eg. breath comp] triggers this already in-between ticks, pre-empting this timer.
					(so it's mostly just a fallback; it's therefore recommended to set this interval higher than other sources, eg. 1s)
				`.AsMultiline(0)}>Base apply interval:</TextPlus>
				<Spinner enabled={enabled} value={config.effectBaseApplyInterval} onChange={val=>ChangeConfig(c=>c.effectBaseApplyInterval = val)}/>
				<Text>s</Text>
			</RowLR>

			<Row mt={15} style={{fontSize: 18, fontWeight: "bold"}}>Battery low</Row>
			<RowLR mt={5} splitAt={splitAt}>
				<TextPlus info={`
					If battery-level is below this AND device is not charging, the battery-low alert becomes active.
				`.AsMultiline(0)}>Battery low, threshold:</TextPlus>
				<SpinnerForPercent enabled={enabled} value={config.batteryLow_threshold} onChange={val=>ChangeConfig(c=>c.batteryLow_threshold = val)}/>
				<CheckBox ml={10} text="Slow-charge detection" value={config.batteryLow_slowChargeDetection} onChange={val=>ChangeConfig(c=>c.batteryLow_slowChargeDetection = val)}/>
				<InfoButton ml={5} text={`
					Some chargers work slowly enough that the device doesn't report itself as "charging", even though it actually (slowly) is.
					If enabled, this option lets charging be inferred from slight battery-level increases.
				`.AsMultiline(0)}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt}>
				<TextPlus info={`
					The brightness to lock the light to, when the battery-low alert is active.
				`.AsMultiline(0)}>Battery low, lock lights to:</TextPlus>
				<SpinnerForPercent enabled={enabled} value={config.batteryLow_lockLightsToBrightness} onChange={val=>ChangeConfig(c=>c.batteryLow_lockLightsToBrightness = val)}/>
			</RowLR>

			<Row mt={15} style={{fontStyle: "italic"}}>{`Note: Other alerts (eg. Breath -> Belt loose) are configured in their respective components.`}</Row>
		</Column>
	);
});